import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import UserService from "../services/UserService";

export const UserContext = createContext("UserContext");

const UserContextProvider = ({children}) => {

    const [userList, setUserList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingUserList, setLoadingUserList] = useState(false);

    const getUserList = async params => {

        try {
            setLoadingUserList(true);
            const res = await UserService.getUserList(params);
            setUserList(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoadingUserList(false);
        } catch (error) {
            setLoadingUserList(false);
            const message = getErrorMessage(error);
            Toast('error', "Error", message);
        }

    }

    return (
        <UserContext.Provider
            value={{
                getUserList,
                userList,
                loadingUserList,
                totalElements
            }}
        >
            {children}
        </UserContext.Provider>
    );
}

export default UserContextProvider;
